



















import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CampaignListItem from '@/components/organisms/OfferFreeCoins/CampaignListItem.vue';
import ProgramStatusTag from '@/componentsV2/atoms/ProgramStatusTag/ProgramStatusTag.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';

import { campaignStatisticsFilter } from '@/utils/campaignStatisticsFilter';

@Component({
  components: {
    Typography,
    CampaignListItem,
    ProgramStatusTag,
    GhostButton,
    ArrowRightInfoIcon
  }
})
export default class WelcomeCoinsItem extends Vue {
  @Prop() item!: any;

  goToWelcomeCoinDetail() {
    this.$router.push({
      path: `/marketing-center/offer-free-coins/${this.item.id}`,
      ...(this.item.createdAt && {
        query: campaignStatisticsFilter(this.item.createdAt)
      })
    });
  }
}
